import Vue from 'vue'
import Bus from '../../config/bus';
import Cookies from 'js-cookie'
import { aes } from './aes.js'
export default {
    created() {
        this.getKey();
        this.getImgcode()
            //window.location.href = "http://10.1.40.142/";
    },
    data() {
        const validateCode = (rule, value, callback) => {
            value = this.formItem.imgcode
            if (!value) {
                return callback(new Error('请输入验证码'));
            }
            if (value.length <= 4) {
                callback(new Error('请输入正确的验证码'));
            } else {
                this.$http.get("front/session/verifyCode?imgCode=" + this.formItem.imgcode).then((res) => {
                    if (res.data.status == 1) {
                        callback();
                    } else {
                        this.$Notice.error({
                            title: '错误',
                            desc: res.data.message
                        })
                        this.getImgcode();
                    }

                }, err => {
                    this.isLoading = false
                    this.$Message.error('验证码验证失败');
                    this.getImgcode();
                })
            }
        };
        const validatePass = (rule, value, callback) => {
          if (value === '') {
              callback(new Error('请输入密码'));
          } else if (!(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,20}$/.test(value))) {
              callback(new Error('8-20位字母数字特殊字符至少包含两种'));
          } else {
              if (this.formValidate.passwordConfirm !== '') {
                  // 对第二个密码框单独验证
                  this.$refs.formValidate.validateField('passwordConfirm');
              }
              callback();
          }
        };
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('确认密码不能为空'))
            } else if (value !== this.formValidate.password) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        };
        const validateTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'))
            } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
                callback(new Error('手机号格式不正确'))
            } else {
                callback();
            }
        };
        return {
            isshow:false,
            isLoading: false,
            maskStyle: { opacity: 0 },
            forgetPassModal:false,
            isModalVisible:false,
            isModalCancel:false,
            codeInfo: 0,
            timer:null,
            verifiPass:false,
            formItem: {
                username: localStorage.getItem('remember:username') || '',
                password: localStorage.getItem('remember:password') || '',
                imgcode: '',
                imagelink: '',
                remember: false
            },
            commitItem: {
                username: '',
                password: '',
                key: '',
                authCode: ''
            },
            formInline:{
                username: '',
                phone:'',
                password:'',
                veryfiycode:''
            },
            ssobind: {
                mobile:'',
                code: ''
            },
            ssomodal: false,
            listmodal: false,
            ssolist:[],
            ssoRules:{
                mobile:[{
                    required: true,
                    validator: validateTel,
                    trigger: 'blur'
                }],
                code: [{
                    required: true,
                    message: '验证码不能为空',
                    trigger: 'blur'
                }],
            },
            formRules: {
                username: [{
                    required: true,
                    message: '请填写用户名',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '请填写密码',
                    trigger: 'blur'
                }, {
                    type: 'string',
                    min: 8,
                    message: '密码长度不能小于8位',
                    trigger: 'blur'
                }],
                verifyCode: [
                    { validator: validateCode, trigger: 'blur' }
                ]
            },
            formValidate: {
              "id": 0,
              "password": "",
              "passwordConfirm": "",
            },
            ruleValidate: {
              password: [{
                      required: true,
                      message: '密码不能为空',
                      trigger: 'blur'
                  },
                  {
                      type: 'string',
                      min: 8,
                      max: 20,
                      message: '密码为8-20位字符',
                      trigger: 'blur'
                  },
                  {
                      validator: validatePass,
                      trigger: 'blur'
                  }
              ],
              passwordConfirm: [{
                      required: true,
                      message: '确认密码不能为空',
                      trigger: 'blur'
                  },
                  {
                      validator: validatePassCheck,
                      trigger: 'blur'
                  }
              ],
            },
            pwtips:false,
            updatedialog:false,
            gosso: false,
            gossocontent: ''
        }
    },

    methods: {
        getKey() {
            this.$http.get('front/studio/login', null).then(res => {
                if (res.data.status == 1) {
                    this.commitItem.key = res.data.key;
                }
            }, err => {
                this.$Message.error('网络不稳定，请再次尝试');
            })
        },
        checkpw(){
            if (!(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,20}$/.test(this.formItem.password))){
                this.pwtips=true;
            }else{
                this.pwtips=false;
            }
        },
        passVerifi(){
            if (!(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,20}$/.test(this.formInline.password))){
                this.verifiPass=true;
            }else{
                this.verifiPass=false;
            }
        },
        submitForm(name) {
            this.$refs[name].validate((valid) => {
                if (valid&&!this.verifiPass) {
                    this.$http.post('front/studio/modifypassword', {
                        username:this.formInline.username,
                        mobile: this.formInline.phone,
                        password: this.formInline.password,
                        code: this.formInline.veryfiycode
                    }).then(res => {
                        if (res.data.status == 1) {
                            this.$Notice.success({
                                title: '修改密码成功！',
                                desc: false
                            })
                        this.cancalForm();
                        } else {
                            this.$Notice.error({
                                title: res.data.message ? res.data.message : '修改密码失败',
                                desc: false
                            });
                        }
                    }, err => {
                        this.$Notice.error({
                            title: err.data.message ? err.data.message : '修改密码失败',
                            desc: false
                        });
                    })
                } else {
                    this.$Notice.warning({
                        title: '请填写正确格式的信息！',
                        desc: false
                    });
                }
            })
        },
        cancalForm(){
            this.forgetPassModal=false;
            this.ssomodal = false
            $(".sendCode").html('发送验证码');
            $(".sendCode").css({
                'background': '#F95759',
                'borderColor': '#F95759'
            });
            clearInterval(this.timer);
            this.codeInfo = 0;
        },
        ssosubmit(){
            this.$refs.ssobind.validate((valid) => {
                if (valid) {
                    this.$http.put('front/account/bindsso', {
                        mobile: this.ssobind.mobile,
                        code: this.ssobind.code,
                        key: this.commitItem.key,
                        username: this.commitItem.username,
                        password: this.commitItem.password
                    }).then(res => {
                        if(res.data.status==1){
                            this.ssomodal = false
                            let userinfo = JSON.parse(localStorage.getItem('userinfo'))
                            if(userinfo.typeCode == "Studio"){
                                var now = new Date()
                                var time = new Date('2022-08-31')
                                if(now>time){
                                    if(!localStorage.getItem('showupdatedialog')){
                                        localStorage.setItem('showupdatedialog', 1)
                                        this.updatedialog=true
                                        return
                                    }
                                } else {
                                    localStorage.removeItem('showupdatedialog')
                                    this.updatedialog=true
                                    return
                                }
                            }
                            this.showpassworddialog()
                        } else {
                            this.$Notice.error({
                                title: '错误',
                                desc: res.data.message
                            })
                        }
                    }, err => {
                        this.$Notice.error({
                            title: err.data.message ? err.data.message : '发送失败',
                            desc: false
                        });
                    })
                }
            })
        },
        sendCode(mobile, type) {
            this.codeInfo++;
            if(!mobile){
                this.$Notice.error({
                    title: '请填写手机号',
                    desc: false
                });
                return
            }
            if (this.codeInfo == 1) {
                let num = 60;
                let This = this;
                this.$http.post('front/studio/getsmscode', {
                    mobile: mobile,
                    type: type
                }).then(res => {
                    if (res.data.status == 1) {
                        $(".sendCode").css({
                            'borderColor': '#999',
                            'background': '#999'
                        });
                        $(".sendCode").html(num + '秒');
                        this.timer = setInterval(function() {
                            num--;
                            $(".sendCode").html(num + '秒');
                            if (num < 0) {
                                $(".sendCode").html('发送验证码');
                                $(".sendCode").css({
                                    'background': '#F95759',
                                    'borderColor': '#F95759'
                                });
                                clearInterval(This.timer);
                                This.codeInfo = 0;
                            }
                        }, 1000)
                    } else {
                        this.codeInfo = 0;
                        this.$Notice.error({
                            title: res.data.message ? res.data.message : '发送失败',
                            desc: false
                        });
                    }
                }, err => {
                    this.codeInfo = 0;
                    this.$Notice.error({
                        title: err.data.message ? err.data.message : '发送失败',
                        desc: false
                    });
                })
            } else {
                this.$Notice.warning({
                    title: '不能重复发送验证码',
                    desc: false
                });
            }
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.commitItem.username = this.formItem.username;
                    this.commitItem.password = aes.cloudPasswordEncrypt(this.commitItem.key, this.commitItem.key, this.formItem.password);
                    this.commitItem.imgcode = this.formItem.imgcode;
                    this.submitLogin();
                }
            })
        },
        forgetPass(){
            this.forgetPassModal=true;
            this.formInline.username='';
            this.formInline.phone='';
            this.formInline.password='';
            this.formInline.veryfiycode='';
            this.verifiPass=false;
        },
        // 登录请求发送
        submitLogin() {
            this.isLoading = true
            this.$http.delete('front/session').then(res => {
                if (res.data.status == 1) {
                    localStorage.removeItem("userinfo");
                    this.$store.commit('set', {
                        userinfo: {}
                    })
                    this.$http.post('front/session', this.commitItem).then(res => {
                            if (res.data.status == 1 && res.data.data) {
                                let data = res.data.data;
                                var userinfo = data;
                                this.$store.commit('set', { userinfo })
                                this.$store.commit('set', {
                                    token: res.data.token
                                })
                                localStorage.setItem('userinfo', JSON.stringify(userinfo))
                                this.$Message.success('登录成功!')
                                Cookies.remove('clickedNo'); //删除对应的cookie
                                Cookies.remove('clickedCo'); //删除对应的cookie
                                // 记住密码
                                // if (this.formItem.remember) {
                                //     localStorage.setItem('remember:username', this.formItem.username)
                                //     localStorage.setItem('remember:password', this.formItem.password)
                                //     localStorage.setItem('remember', 1)
                                // } else {
                                //     localStorage.removeItem('remember:username')
                                //     localStorage.removeItem('remember:password')
                                //     localStorage.removeItem('remember')
                                // }
                                this.commitItem.username = data.username
                                this.ssomodal = true
                                this.$refs.ssobind.resetFields()
                                // if(userinfo.typeCode == "Studio"){
                                //     var now = new Date()
                                //     var time = new Date('2022-08-31')
                                //     if(now>time){
                                //         if(!localStorage.getItem('showupdatedialog')){
                                //             localStorage.setItem('showupdatedialog', 1)
                                //             this.updatedialog=true
                                //             return
                                //         }
                                //     } else {
                                //         localStorage.removeItem('showupdatedialog')
                                //         this.updatedialog=true
                                //         return
                                //     }
                                // }
                                // this.showpassworddialog()
                            } else {
                                if(res.data.status===55){
                                    this.gossocontent = res.data.message
                                    this.gosso = true
                                } else {
                                    if(res.data.status===5 && res.data.redirectURL){
                                        Bus.$emit('logout')
                                        window.location.href = res.data.redirectURL
                                        window.reload()
                                    }
                                    this.isshow = true
                                    this.$Notice.error({
                                        title: '错误',
                                        desc: res.data.message
                                    })
                                    this.getImgcode();
                                }
                            }
                            this.isLoading = false
                        }, err => {
                            this.isLoading = false
                            this.$Message.error('网络不稳定，请再次尝试');
                            this.getImgcode();
                        })
                        // this.$Message.success('退出成功')
                } else {
                    this.$Message.error(res.data.message)
                }
                //this.$router.push('/login')
            }, err => {
                this.$Message.error(JSON.stringify(err))
            })

        },
        gossopage(){
            window.location.href = this.$conf.serverRoot+'front/sso/login?referer='+(this.$route.query.referer||'')
        },
        // getssolist(){
        //     this.$http.get('front/account/list?ssoUid',function(res){
        //         if(res.data.status===1){
        //             this.ssolist = res.data.data
        //         }
        //     })
        //     this.listmodal = true
        // },
        // 获取验证码
        getImgcode() {
            this.formItem.imgcode = "";
            this.formItem.imagelink = this.$conf.serverRoot + "front/authCode.png?" + new Date().getTime()
        },
        handleOk(){
          this.$refs.formValidate.validate((valid) => {
            if (valid) {
              this.formValidate.oldPassword = this.formItem.password;
              var data = Object.assign({}, this.formValidate)
              if (!data.password) {
                  delete data.password
                  delete data.passwordConfirm
              }
              this.isSubmit = true
              this.$http.post('front/studio/modifypassword/change', data).then(({
                  data
              }) => {
                  this.isSubmit = false
                  if (data.status === 1) {
                      this.$Notice.success({
                          title: '成功',
                          desc: data.message || '保存成功'
                      })

                      if (this.$store.state.userinfo.completeinfo == "Y" && this.$store.state.userinfo.typeCode == "Studio") {
                        this.$router.push('/entering')
                      }else{
                        this.$router.push('/')
                      }

                  } else {
                      this.$Notice.error({
                          title: '错误',
                          desc: data.message || '保存错误'
                      })
                  }
              }, () => {
                  this.isSubmit = false
                  this.$Notice.error({
                      title: '错误',
                      desc: '保存错误'
                  })
              })
            }
          })
        },
        onCancel(){
          this.formValidate.password = ''
          this.formValidate.passwordConfirm = ''
          this.isModalVisible = false;
          this.isModalCancel = true;
        },
        clickCancel(){
          if (this.$store.state.userinfo.completeinfo == "Y" && this.$store.state.userinfo.typeCode == "Studio") {
            this.$router.push('/entering')
          }else{
            this.$router.push('/')
          }
        },
        allowSubmit() {
          if (this.disabledS && !this.firstLoad) {
              this.disabledS = false
              this.firstLoad = false
          } else {
              this.disabledS = false
              this.firstLoad = false
          }
        },
        showpassworddialog(){
            window.routeReady = true;
            if (this.$store.state.userinfo.completeinfo == "Y" && this.$store.state.userinfo.typeCode == "Studio") {
                if (!(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,20}$/.test(this.formItem.password))){
                    this.isModalVisible = true;
                }else{
                    this.$router.push('/entering')
                }
            } else {
                if (this.$store.state.userinfo.typeCode == "Admin") {
                this.$router.push('/')
                }else{
                if (!(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,20}$/.test(this.formItem.password))){
                    this.isModalVisible = true;
                }else{
                    this.$router.push('/')
                }
                }
            }
        },
        updateCancel(){
            this.updatedialog=false
            this.showpassworddialog()
        }
    },

    mounted() {
        localStorage.removeItem('summaryTip')
    },
    watch:{
        forgetPassModal(bool) {
            if (!bool) {
                $(".sendCode").html('发送验证码');
                $(".sendCode").css({
                    'background': '#F95759',
                    'borderColor': '#F95759'
                });
                clearInterval(this.timer);
                this.codeInfo = 0;
            }
        },
        ssomodal(bool) {
            if (!bool) {
                $(".sendCode").html('发送验证码');
                $(".sendCode").css({
                    'background': '#F95759',
                    'borderColor': '#F95759'
                });
                clearInterval(this.timer);
                this.codeInfo = 0;
            }
        },
    }

}



// WEBPACK FOOTER //
// ./src/view/login/index.js